import { ForwardedRef, forwardRef } from 'react';
// Local Imports
import {
  AppSettingsIcon,
  CrossIcon,
  NotSuspendUserIcon,
  SuspendUserIcon,
  TickMarkIcon,
} from '../../../assets/icons';

interface TableActionsProps {
  children: any;
  placement?: string;
  width?: string;
  height?: string;
  className?: string;
  restProps: { [key: string]: any };
  isActive: boolean;
  onToggle: any;
}

const Status = (status: boolean, activeText: string, inactiveText: string) => {
  return status ? (
    <div className='flex justify-start items-center gap-[5px]'>
      <TickMarkIcon />
      {activeText}
    </div>
  ) : (
    <div className='flex justify-start items-center gap-[5px]'>
      {inactiveText === 'Verified' ? (
        <CrossIcon className='!text-danger' />
      ) : (
        <div className='w-[12px] h-[12px] rounded-full ring-danger ring-2 text-danger'></div>
      )}
      {inactiveText}
    </div>
  );
};
// Account Status
export const accountStatus = (
  status: boolean,
  activeText: string,
  inactiveText: string
) => {
  return status ? (
    <div className='flex justify-start items-center gap-[5px]'>
      <SuspendUserIcon className=' w-[20px] h-[20px] fill-danger' />
      {activeText}
    </div>
  ) : (
    <div className='flex justify-start items-center gap-[5px]'>
      <NotSuspendUserIcon className=' w-[20px] h-[20px] fill-success' />
      {inactiveText}
    </div>
  );
};

// ACTION IN TABLE
export const TableAction = (
  {
    children,
    restProps,
    placement,
    width,
    height,
    className,
    isActive,
    onToggle,
  }: TableActionsProps,
  ref: ForwardedRef<any>
) => {
  const index = restProps?.row?.index;

  // useOnClickOutside();

  return (
    <div className='cursor-pointer  min-w-max relative'>
      <AppSettingsIcon
        className='translate-x-3'
        onClick={() => onToggle(index)}
      />
      {isActive && (
        <div
          className={`popover p-2 ${
            isActive ? 'open' : ''
          }  bg-white z-50 right-0 rounded-[4px] popover-shadow  ${
            width ? width : 'w-[200px]'
          } ${height ? height : 'h-[200px]'} ${
            placement ? placement : 'right-6 top-7'
          } ${className}`}
          ref={ref}
        >
          {children()}
        </div>
      )}
    </div>
  );
};

//ForwardREF to Handle Popover Closing
export const TableActions = forwardRef<any, TableActionsProps>(TableAction);

export default Status;
